<div class="page-container" [class.loading]="isLoading">
    <app-header
        title="{{ 'payroll.taxAdjuster.yearEndAdjustments' | translate }}"
        [menuService]="payrollModuleMenuService"
    ></app-header>
    @if (hasEmployeesOnPayroll) {
        @if (shouldTaxAdjusterViewBeDisplayed) {
            <div>
                <div class="flex middle space-between">
                    <mat-form-field>
                        <mat-label appRemoveAriaOwns>{{ 'payroll.taxAdjuster.year' | translate }}</mat-label>
                        <mat-select
                            name="yearSelect"
                            required
                            #yearSelect="ngModel"
                            [(ngModel)]="taxSeasonSelected"
                            (ngModelChange)="onYearChangeSelected()"
                        >
                            <mat-option *ngFor="let year of taxAdjustableYears" [value]="year">{{ year }}</mat-option>
                        </mat-select>
                        @if (yearSelect.invalid) {
                            <mat-error>{{ yearSelect.errors | formErrors }}</mat-error>
                        }
                    </mat-form-field>
                    @if (hasAddFormFlag()) {
                        <ui-button type="primary" (click)="addTaxFormDialog.isOpen = true; loadOfficeJurisdictions()">
                            <mat-icon svgIcon="plus" /> {{ 'payroll.taxAdjuster.addTaxForm.launchButton' | translate }}
                        </ui-button>
                    }
                </div>
                <p
                    class="margin-bottom-3"
                    [innerHTML]="
                        'payroll.taxAdjuster.useTheTableBelowToInputEarningsAndDeductionsValuesForEmployeeT4s'
                            | translate
                    "
                ></p>
                @if (renderTaxAdjusterTable) {
                    <ui-card>
                        @if (shouldShowTabs) {
                            <app-child-tab-bar (onTabChange)="onTabChange($event)">
                                @for (payroll of yearEndAdjustmentPayrolls; track payroll.payrollId) {
                                    <app-child-tab
                                        [value]="payroll.payrollId"
                                        [initiallyActive]="selectedPayroll === payroll.payrollId"
                                        >{{ payroll.jurisdiction }}</app-child-tab
                                    >
                                }
                            </app-child-tab-bar>
                        }
                        @if (selectedPayroll) {
                            <app-grid
                                #taxAdjusterGrid
                                [columnDefs]="taxAdjusterTableColumnDefs[selectedPayroll]"
                                [rowData]="taxAdjusterTableRowData[selectedPayroll]"
                                [returnRawColumnEditEvent]="true"
                                [undoRedoCellEditing]="true"
                                [allChangesSaved]="allChangesSaved"
                                [displayErrorState]="displayErrorState"
                                [errorString]="errorString"
                                (gridSearchEmitter)="handleFilter($event, currentTable)"
                                [gridOptions]="gridOptions"
                            >
                            </app-grid>
                        }
                    </ui-card>
                }
            </div>
        } @else {
            <p>{{ 'payroll.taxAdjuster.cannotDisplayTaxAdjuster' | translate }}</p>
        }
    } @else if (!isLoading) {
        <ui-card>
            <div class="flex col middle">
                <img class="w-25" src="/assets/illustrations/sofa.png" />
                <p class="margin-top-2">{{ 'payroll.taxAdjuster.noEmployeesOnPayroll' | translate }}</p>
            </div>
        </ui-card>
    }
</div>

<ui-dialog
    size="small"
    header="payroll.taxAdjuster.addTaxForm.dialog.header"
    [open]="addTaxFormDialog.isOpen"
    (closing)="closeAddTaxFormDialog()"
    [isCloseable]="!addTaxFormDialog.isLoading"
>
    <div class="flex col loadable" [class.loading]="addTaxFormDialog.isLoading">
        <div class="margin-bottom-3">
            {{ 'payroll.taxAdjuster.addTaxForm.dialog.description' | translate }}
        </div>
        <mat-form-field>
            <mat-label>{{ 'payroll.taxAdjuster.addTaxForm.dialog.employee' | translate }}</mat-label>
            <mat-select [(ngModel)]="addTaxFormDialog.employeeId">
                @for (employee of employees; track employee.id) {
                    <mat-option [value]="employee.prEmployeeId">{{ employee.fullName }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-form-field class="margin-bottom-2">
            <mat-label>{{ 'payroll.taxAdjuster.addTaxForm.dialog.jurisdiction' | translate }}</mat-label>
            <mat-select [(ngModel)]="addTaxFormDialog.jurisdiction">
                @for (jurisdiction of officeJurisdictions; track $index) {
                    <mat-option [value]="jurisdiction">
                        <span translate="provinces.{{ jurisdiction }}"></span>
                    </mat-option>
                }
            </mat-select>
            <mat-hint>
                {{ 'payroll.taxAdjuster.addTaxForm.dialog.jurisdictionHint' | translate }}
            </mat-hint>
        </mat-form-field>
        <ui-dialog-footer
            ><ui-button (click)="closeAddTaxFormDialog()">{{ 'cancel' | translate }}</ui-button
            ><ui-button
                (click)="handleAddTaxForm()"
                type="primary"
                [disabled]="!addTaxFormDialog.jurisdiction || !addTaxFormDialog.employeeId"
                >{{ 'payroll.taxAdjuster.addTaxForm.launchButton' | translate }}</ui-button
            ></ui-dialog-footer
        >
    </div>
</ui-dialog>
